'use client';

import NextImage, {
  getImageProps,
  type ImageProps,
} from 'next/image';

import { directusImageWrapperLoader } from '@/utils/directus-image-wrapper-loader';
import { directusImageLoader } from '@/utils/loaders';

const USE_DIRECTUS_IMAGES =
  process.env.NEXT_PUBLIC_USE_DIRECTUS_IMAGES === 'true';

export type { ImageProps };

export default function Image(props: ImageProps) {
  const { src } = props;

  // rollback switch
  if (!USE_DIRECTUS_IMAGES) {
    return <NextImage {...props} />;
  }

  // local images, svg imports, blur placeholders
  if (
    typeof src !== 'string' ||
    !src.startsWith('http')
  ) {
    return (
      <NextImage
        {...props}
        loader={directusImageLoader}
      />
    );
  }

  const loader = props.loader ?? directusImageWrapperLoader;

  const { props: imgProps } = getImageProps({
    ...props,
    loader,
  });

  return (
    // eslint-disable-next-line @next/next/no-img-element, jsx-a11y/alt-text
    <img {...imgProps} />
  );
}